import * as React from 'react';

import Lottie from 'lottie-react-web';

import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';

import { LoyaltyLoadingAnimation } from '../loyalty-lottie-animations';

import { LoyaltyLoaderContainer } from './loyalty-loader.styled';

const LoyaltyLoader = ({ className }: { className?: string }) => {
  const isDesktop = useMediaQuery(MediaQuery.Desktop);
  const defaultOptions = {
    animationData: LoyaltyLoadingAnimation,
    autoplay: true,
    loop: true,
  };
  return (
    <LoyaltyLoaderContainer className={className}>
      <Lottie options={defaultOptions} width={isDesktop ? 180 : 140} />
    </LoyaltyLoaderContainer>
  );
};

export default LoyaltyLoader;
